import { EN, NL } from "./constants";

export const locales = [
  { name: NL, title: "Nederlands", titleEn: "Dutch" },
  { name: EN, title: "Engels", titleEn: "English" },
];
